import ApprovedReceiverLicenses from './ApprovedReceiverLicenses'
import ApprovedShipperLicenses from './ApprovedShipperLicenses'
import Collection from './Collection'
import DriverInfo from './DriverInfo'
import Order from './Order'
import OrderConfirmationCode from './OrderConfirmationCode'
import OrderDetails from './OrderDetails'
import OrderDriverMessage from './OrderDriverMessage'
import OrderShipperMessage from './OrderShipperMessage'
import Org from './Org'
import OrgMembershipInvite from './OrgMembershipInvite'
import OrgRegistrationCode from './OrgRegistrationCode'
import ProviderAccount from './ProviderAccount'
import ProviderConnection from './ProviderConnection'
import ProviderBrand from './ProviderBrand'
import ProviderOrder from './ProviderOrder'
import ProviderOrderDiff from './ProviderOrderDiff'
import ProviderOrderSubmission from './ProviderOrderSubmission'
import Receiver from './Receiver'
import ReceiverLicenseChangeReceipt from './ReceiverLicenseChangeReceipt'
import RecipientEmail from './RecipientEmail'
import Route from './Route'
import Shipper from './Shipper'
import User from './User'
import Vehicle from './Vehicle'
import VehicleLot from './VehicleLot'

export default {
  ApprovedReceiverLicenses,
  ApprovedShipperLicenses,
  Collection,
  DriverInfo,
  Order,
  OrderConfirmationCode,
  OrderDetails,
  OrderDriverMessage,
  OrderShipperMessage,
  Org,
  OrgMembershipInvite,
  OrgRegistrationCode,
  ProviderAccount,
  ProviderConnection,
  ProviderBrand,
  ProviderOrder,
  ProviderOrderDiff,
  ProviderOrderSubmission,
  Receiver,
  ReceiverLicenseChangeReceipt,
  RecipientEmail,
  Route,
  Shipper,
  User,
  Vehicle,
  VehicleLot
}
